/*
  productCategories format:

  {
    id: 1,
    name: 'abc',
    product_category_ids_sorts: [
      {id: 2, name: 'def', product_category_ids_sorts: [], product_ids_sorts: [], sort: ''},
      {id: 3, name: 'ghi', product_category_ids_sorts:[], product_ids_sorts: [], sort: ''}
    ],
    product_ids_sorts: [1, 2, 3],
    sort: ''
  };
  
*/

import React from 'react';
import TreeView from 'react-treeview';
import { Button } from 'react-bootstrap';

import DeleteBtnWithConfirm from './DeleteBtnWithConfirm';

const style = {
  // fontSize: 12,
  height: 26,
  // lineHeight: '20px',
  padding: '1px 3px',
  marginLeft: 8,
  marginTop: -4.5
};

const CustButton = props => (
  <Button
    style={style}
    onClick={props.onClick}>

    {props.content}

  </Button>
);

// 每次點擊node就必須run一次，因為儲存起來的虛擬dom的狀態會維持在當時
// 至少不用每次render都map一次
export default function treeViewGenerator(productCategories, collapsesState, cbForNodeClick, activeCategoryTracks, enableEdit, cbForModifyClick, nameKey) {
  let tracks = [0],
    trackNames = [productCategories[nameKey] || '所有分類'],
    trackIds = ['0'];

  const rootNodeLabel = (
    <span>
      <span className='node' onClick={() => { cbForNodeClick(productCategories, tracks, trackNames, trackIds) }}>
        {productCategories[nameKey] || '所有分類'}
      </span>
      {
        enableEdit ?
          <span>
            <CustButton content="新增子類別" onClick={() => { cbForModifyClick('create', trackIds); }} />
            {/*<CustButton content="修改" onClick={() =>{cbForModifyClick('edit', trackIds);}} />*/}
          </span>
          :
          ""
      }
    </span>
  ),
    collapsKey = productCategories.id;



  if (collapsesState[collapsKey] === undefined) collapsesState[collapsKey] = true;

  // recurring function
  const treeNodeGenerator = (parentObj, arrTracks, arrTrackNames, arrTrackIds) => {
    const childCategories = parentObj.product_category_ids_sorts;

    if (childCategories && childCategories.length && childCategories[0].product_category_ids_sorts) {

      return childCategories.map((item, ind) => {
        // 複製parent path
        let tracks = arrTracks.slice(),
          trackNames = arrTrackNames.slice(),
          trackIds = arrTrackIds.slice();
        // 記入sort
        tracks.push(ind);
        trackNames.push(item[nameKey] || 'No name');
        trackIds.push(item.id);

        const collapsKey = item.id,
          canDelete = ((!item.product_category_ids_sorts || !item.product_ids_sorts || item.product_category_ids_sorts.length || item.product_ids_sorts.length) ? false : true),
          nodeLabel = (
            <span>
              <span className='node' onClick={() => { cbForNodeClick(parentObj, tracks, trackNames, trackIds); }}>
                {item[nameKey] || 'No name'}
              </span>
              {
                enableEdit ?
                  <span>
                    <CustButton content="新增子類別" onClick={() => { cbForModifyClick('create', trackIds, parentObj, ind); }} />
                    <CustButton content="修改" onClick={() => { cbForModifyClick('edit', trackIds, parentObj, ind); }} />
                    <CustButton content="複製" onClick={() => { cbForModifyClick('copy', trackIds, parentObj, ind); }} />
                    {canDelete ? <DeleteBtnWithConfirm style={style} title="Are you sure?" onClick={() => { cbForModifyClick('delete', trackIds, parentObj, ind); }} /> : ""}
                  </span>
                  :
                  ""
              }
            </span>
          );

        if (collapsesState[collapsKey] === undefined) collapsesState[collapsKey] = true;

        return (
          <TreeView
            key={item.id}
            itemClassName={activeCategoryTracks === collapsKey ? 'active-category' : ""}
            nodeLabel={nodeLabel}
            collapsed={collapsesState[collapsKey]}
            onClick={() => { cbForNodeClick(parentObj, tracks, trackNames, trackIds); }}
          >
            {treeNodeGenerator(item, tracks, trackNames, trackIds)}
          </TreeView>
        );

      });
    }
  };

  return {
    productTreeView: (
      <TreeView
        itemClassName={activeCategoryTracks === collapsKey ? 'outer-tree-view-item active-category' : 'outer-tree-view-item'}
        nodeLabel={rootNodeLabel}
        collapsed={collapsesState[collapsKey]}
        onClick={() => { cbForNodeClick(productCategories, tracks, trackNames, trackIds); }}
      >
        {treeNodeGenerator(productCategories, tracks, trackNames, trackIds)}
      </TreeView>
    ),
    collapsesState
  };
};


// WEBPACK FOOTER //
// ./src/commonComponents/treeViewGenerator.jsx